import { useLocation } from "react-router-dom";
import MainContent from "../../../components/mainContent/MainContent"
import { ImprimirMinutaDetalleContent } from "./ImprimirMinutaDetalleContent"

export const ImprimirMinutaDetalle = () => {
    const location = useLocation();
    const { allowedWrite, dataRegistro, delegacion } = location.state; 
    
    return (
        <MainContent
            component={<ImprimirMinutaDetalleContent                 
                allowedWrite={allowedWrite}
                dataRegistro={dataRegistro} 
                delegacion={delegacion}
            />}
            titulo={"Visualización de Minuta"}
            noBackground
            tableMaxWidth
        />
    )    
}